export default __webpack_public_path__ + "clientapp/media/robot-10.55cb4b1f.png";